/*
 * @Description:
 * @Author: lyy
 * @Date: 2022-07-21 17:33:36
 * @LastEditors: your Name
 * @LastEditTime: 2022-07-28 14:59:13
 */
const routerLoadingMaps = {
  // beforeLogin
  BeforeLoginIndex: () =>
    import(/* webpackChunkName: "beforeLogin" */ "@/views/beforeLogin/BeforeLoginIndex.vue"),
  Login: () =>
    import(/* webpackChunkName: "beforeLogin" */ "@/views/beforeLogin/LoginIndex.vue"),
  Register: () =>
    import(/* webpackChunkName: "beforeLogin" */ "@/views/beforeLogin/register/RegisterIndex.vue"),

  HomeIndex: () =>
    import(/* webpackChunkName: "about" */ "@/views/HomeIndex.vue"),

  //我的财务
  MyFinance: () =>
    import("@/views/myFinance/MyFinanceIndex.vue"),
  //申保管理
  ApplyInsurance: () =>
  import("@/views/applyInsuranceManagement/ApplyInsuranceIndex.vue"),
  //核保
  UnderwritingManagement: () =>
    import("@/views/underwritingManagement/UnderwritingIndex.vue"),
  //第三方跳转
  JumpPage: () => import("@/views/JumpPage.vue"),

};

export default [
  {
    path: "/BeforeLoginIndex",
    name: "BeforeLoginIndex",
    component: routerLoadingMaps.BeforeLoginIndex,
    redirect: "login",
    children: [
      {
        path: "/login",
        name: "login",
        component: routerLoadingMaps.Login,
      },
      {
        path: "/register",
        name: "register",
        component: routerLoadingMaps.Register,
      },
    ]
  },
  {
    path: "/",
    name: "jumpPage",
    component: routerLoadingMaps.JumpPage
  },
  {
    path: "/home",
    name: "home",
    component: routerLoadingMaps.HomeIndex,
    redirect: {
      name: 'myFinance'
    },
    children: [
      {
        //我的财务
        path: "/myFinance",
        name: "myFinance",
        component: routerLoadingMaps.MyFinance,
      },
      {
        path: "/applyInsurance",
        name: "applyInsurance",
        component: routerLoadingMaps.ApplyInsurance,
      }, {
        path: "/underwritingManagement",
        name: "underwritingManagement",
        component: routerLoadingMaps.UnderwritingManagement,
      }
    ]
  }
];
